<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Default look and feel" />
    <vc-tag>I'm a tag</vc-tag>
    <example-title src="example-2.html" title="Tags list from array" />
    <vc-tag v-for="(tag, index) in tags1" :key="`${index}-0`">{{ tag.name }}</vc-tag>
    <div :class="['mt-16']">
      <code>v-model: {{ tags1 }}</code>
    </div>
    <example-title src="example-3.html" title="Closable colored tags from array" />
    <vc-tag v-for="(tag, index) in tags2" :dark="tag.dark" :color="tag.color" @close="close(index, tags2)" closable :key="`${index}-1`">{{ tag.color }}</vc-tag>
    <div :class="['mt-16']">
      <code>v-model: {{ tags2 }}</code>
    </div>
    <example-title src="example-4.html" title="Tags as HTML links" />
    <vc-tag tag="a" color="green" to="https://vuejs.org/" target="_blank">Vue</vc-tag>
    <vc-tag tag="a" color="blue" to="https://vuex.vuejs.org/en/" target="_blank">Vuex</vc-tag>
    <vc-tag tag="a" color="red" to="https://ssr.vuejs.org/en/" target="_blank">Nuxt</vc-tag>
    <vc-tag tag="a" color="purple" to="https://router.vuejs.org/en/" target="_blank">Vue Router</vc-tag>

    <example-title src="example-5.html" title="Tags as Vue Router links" />
    <vc-tag tag="router-link" color="green" to="/components">components</vc-tag>
    <vc-tag tag="router-link" color="blue" to="/layout">layout</vc-tag>
    <vc-tag tag="router-link" color="red" to="/style">style</vc-tag>
    <vc-tag tag="router-link" color="purple" to="/form-elements">form elements</vc-tag>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'TagPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      tags1: [{
        name: 'VueJs'
      }, {
        name: 'Angular'
      }, {
        name: 'React'
      }, {
        name: 'Inferno'
      }],
      tags2: [{
        color: 'default',
        dark: true
      }, {
        color: 'primary',
        dark: true
      }, {
        color: 'info',
        dark: true
      }, {
        color: 'success',
        dark: true
      }, {
        color: 'error',
        dark: true
      }, {
        color: 'warning',
        dark: true
      }, {
        color: 'orange',
        dark: true
      }, {
        color: 'deep-purple l-100',
        dark: false
      }, {
        color: 'green l-100',
        dark: false
      }]
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    close (index, tags) {
      console.log('vc-tag:close', index)
      tags.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tag.vue